export default __webpack_public_path__ + "static/media/beeftrader-background-image-light.c1a53c3a.png";